<template>
  <a-drawer
title="作品详情"
:maskClosable="false"
width="70%"
:visible="open"
@close="onClose"
destroyOnClose>
    <a-spin :spinning="!form.workId">
      <!-- 折叠面板 -->
      <!-- <a-collapse v-model="activeKey" accordion> -->
      <a-collapse v-model="activeKey">
        <!-- 1️⃣ 作品信息 -->
        <a-collapse-panel key="work" header="作品信息">
          <a-descriptions :column="2" bordered size="small">
            <!-- <a-descriptions-item label="作品ID">{{ form.workId }}</a-descriptions-item> -->
            <a-descriptions-item label="订单编号">{{ info.orderNo }}</a-descriptions-item>
            <a-descriptions-item label="所属企业" v-if="info.tenantFirmId !== info.tenantAgentId">{{
              info.tenantFirmName
            }}</a-descriptions-item>
            <a-descriptions-item label="所属经销商" v-if="info.tenantFirmId !== info.tenantId">{{
              info.tenantAgentId == info.tenantId ? info.tenantName : info.tenantAgentName
            }}</a-descriptions-item>
            <a-descriptions-item label="作者">{{ form.extendS1 }}</a-descriptions-item>
            <a-descriptions-item label="企业介绍">
              <a-popover title="企业介绍">
                <template slot="content">
                  {{ form.description }}
                </template>
                <a-button type="primary" v-if="form.description"> 查看 </a-button>
              </a-popover>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="广告语">{{ form.extendS6 || '-' }}</a-descriptions-item>
            <a-descriptions-item label="官网地址">{{ form.websiteVal || '-' }}</a-descriptions-item>
            <a-descriptions-item label="官网电话">{{ form.extendS1 || '-' }}</a-descriptions-item> -->

            <!-- <a-descriptions-item label="企业介绍">{{ form.description || '-' }}</a-descriptions-item> -->
            <a-descriptions-item label="封面图">
              <div v-viewer v-if="form.coverImageUrl">
                <img :src="$url + form.coverImageUrl" alt="" style="width: 50px; height: 50px" />
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="分享图">
              <div v-viewer v-if="form.shareLogoUrl">
                <img :src="$url + form.shareLogoUrl" alt="" style="width: 50px; height: 50px" />
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="补地图">
              <div v-viewer v-if="form.supplementMapUrl">
                <img :src="$url + form.supplementMapUrl" alt="" style="width: 50px; height: 50px" />
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="背景音乐" :span="2" v-if="form.backgroundMusicUrl">
              <!-- <a-button type="primary" @click="togglePlay" :loading="isLoading">
                {{ isPlaying ? '暂停播放' : '开始试听' }}
              </a-button> -->
              <audio
                ref="audio"
                style="width: 400px; height: 80px"
                :src="$url + form.backgroundMusicUrl"
                controls
              ></audio>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="背景音乐循环">
              <a-tag :color="form.backgroundMusicLoop ? 'green' : 'red'">
                {{ form.backgroundMusicLoop ? '是' : '否' }}
              </a-tag>
            </a-descriptions-item> -->
            <a-descriptions-item label="作品状态">
              <a-tag :color="['', 'green', 'orange', 'red'][form.status]">
                {{ ['', '正常', '审核中', '已下架'][form.status] }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="预览">
              <!-- <a-tag :color="form.isPublic ? 'green' : 'red'">
                {{ form.isPublic ? '公开' : '私有' }}
              </a-tag> -->
              <a-button type="primary" @click="handleYu"> 预览 </a-button>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="点赞数">{{ form.likeCount || 0 }}</a-descriptions-item> -->
            <!-- <a-descriptions-item label="查看数">{{ form.viewCount || 0 }}</a-descriptions-item> -->
            <!-- <a-descriptions-item label="作品标签">{{ form.tags || '-' }}</a-descriptions-item>
            <a-descriptions-item label="分类ID">{{ form.categoryId || '-' }}</a-descriptions-item>
            <a-descriptions-item label="订单ID">{{ form.orderId || '-' }}</a-descriptions-item>
            <a-descriptions-item label="租户ID">{{ form.tenantFirmId || '-' }}</a-descriptions-item> -->
            <a-descriptions-item label="创建时间">{{ form.createTime || '-' }}</a-descriptions-item>
            <a-descriptions-item label="占用空间">{{ form.spaceUsage || 0 }} MB</a-descriptions-item>
            <a-descriptions-item label="备注" :span="2">{{ form.remark || '-' }}</a-descriptions-item>
          </a-descriptions>
        </a-collapse-panel>

        <!-- 2️⃣ 场景列表 -->
        <a-collapse-panel key="scenes" :header="`场景列表 (${form.scenesInfos?.length || 0})`">
          <div class="button_add">
            <a-button type="primary" @click="$refs.CreateForm.handleAdd(form)"> 新增 </a-button>
          </div>
          <a-table
            v-if="form.scenesInfos && form.scenesInfos.length"
            :data-source="form.scenesInfos"
            row-key="sceneId"
            size="small"
            :pagination="false"
            bordered
            :columns="sceneColumns"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="handleDelete(record)"> 删除 </a>
              <a @click="$refs.CreateForm.handleUpdate(form, record)"> 修改 </a>
            </span>
            <!-- 默认场景 -->
            <template slot="isDefault" slot-scope="text">
              <a-tag :color="text ? 'green' : ''">
                {{ text ? '是' : '否' }}
              </a-tag>
            </template>

            <!-- 切图状态 -->
            <template slot="cuttingStatus" slot-scope="text">
              <a-tag :color="['orange', 'blue', 'green', 'red'][text]">
                {{ ['未开始', '进行中', '已完成', '失败'][text] }}
              </a-tag>
            </template>

            <!-- 切图进度 -->
            <template slot="cuttingProgress" slot-scope="text">
              <a-progress :percent="text" size="small" />
            </template>

            <!-- 原图 -->
            <template slot="originalImageUrl" slot-scope="text">
              <img :src="$url + text" width="60" />
            </template>

            <!-- 切图 -->
            <template slot="slicedImageUrl" slot-scope="text">
              <img :src="$url + text" width="60" />
            </template>

            <!-- 补地图 -->
            <template slot="supplementMapUrl" slot-scope="text">
              <img :src="$url + text" width="60" />
            </template>

            <!-- 容量统一加单位 -->
            <template slot="originalImageSize" slot-scope="text">{{ text }} MB</template>
            <template slot="slicedImageSize" slot-scope="text">{{ text }} MB</template>
            <template slot="spaceUsage" slot-scope="text">{{ text }} MB</template>
          </a-table>
          <a-empty v-else description="暂无场景" />
        </a-collapse-panel>
      </a-collapse>
    </a-spin>
    <CreateForm ref="CreateForm" @ok="handleDetail"></CreateForm>
  </a-drawer>
</template>

<script>
import { getObj, editSys } from '@/api/VR/vrWork'
import CreateForm from './CreateForm.vue'
import { getObjS } from '@/api/pressure/dispatch'

export default {
  name: 'Detail',
  components: { CreateForm },
  data() {
    return {
      open: false,
      form: {},
      formTitle: '作品详情',
      info: {},
      id: '',
      activeKey: ['work'], // 默认展开第一块
      sceneColumns: [
        { title: '场景名称', width: 90, dataIndex: 'sceneName', key: 'sceneName' },
        // {
        //   title: '默认场景',
        //   dataIndex: 'isDefault',
        //   key: 'isDefault',
        //   scopedSlots: { customRender: 'isDefault' },
        //   align: 'center',
        //   width: 90,
        // },
        // { title: '场景类型', dataIndex: 'sceneType', key: 'sceneType', width: 100 },
        // { title: '场景描述', dataIndex: 'description', key: 'description', ellipsis: true },
        {
          title: '切图状态',
          dataIndex: 'cuttingStatus',
          key: 'cuttingStatus',
          scopedSlots: { customRender: 'cuttingStatus' },
          align: 'center',
          width: 100,
        },
        // {
        //   title: '切图进度',
        //   dataIndex: 'cuttingProgress',
        //   key: 'cuttingProgress',
        //   scopedSlots: { customRender: 'cuttingProgress' },
        //   align: 'center',
        //   width: 100,
        // },
        // { title: '查看次数', dataIndex: 'viewCount', key: 'viewCount', align: 'center', width: 90 },
        // {
        //   title: '原图容量',
        //   dataIndex: 'originalImageSize',
        //   key: 'originalImageSize',
        //   scopedSlots: { customRender: 'originalImageSize' },
        //   align: 'center',
        //   width: 90,
        // },
        // {
        //   title: '切图容量',
        //   dataIndex: 'slicedImageSize',
        //   key: 'slicedImageSize',
        //   scopedSlots: { customRender: 'slicedImageSize' },
        //   align: 'center',
        //   width: 90,
        // },
        // {
        //   title: '场景容量',
        //   dataIndex: 'spaceUsage',
        //   key: 'spaceUsage',
        //   scopedSlots: { customRender: 'spaceUsage' },
        //   align: 'center',
        //   width: 90,
        // },
        {
          title: '原图',
          dataIndex: 'originalImageUrl',
          key: 'originalImageUrl',
          scopedSlots: { customRender: 'originalImageUrl' },
          align: 'center',
          width: 80,
        },
        // {
        //   title: '切图',
        //   dataIndex: 'slicedImageUrl',
        //   key: 'slicedImageUrl',
        //   scopedSlots: { customRender: 'slicedImageUrl' },
        //   align: 'center',
        //   width: 80,
        // },
        // {
        //   title: '补地图',
        //   dataIndex: 'supplementMapUrl',
        //   key: 'supplementMapUrl',
        //   scopedSlots: { customRender: 'supplementMapUrl' },
        //   align: 'center',
        //   width: 80,
        // },
        // { title: '分辨率参数', dataIndex: 'resolutionParams', key: 'resolutionParams', width: 120 },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 150 },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
    }
  },
  methods: {
    handleYu() {
      // window.
      // cosnole(this.form,'ddd顶顶顶顶')
      // console.log(this.form, 'this.formthis.form')
      const url = this.$baseUrl + this.form.workId
      window.open(url)
    },
    handleUpdate(row, ids) {
      const id = row.workId
      if (!id) return
      this.id = id
      this.handleDetail()
    },
    handleDetail() {
      getObj(this.id).then((res) => {
        this.form = res.data || {}
        console.log(this.form, 'this.form ')
        if (res.data.orderId) {
          getObjS(res.data.orderId).then((respon) => {
            console.log(respon, 'responrespon')
            this.info = respon.data
          })
        }
        this.open = true
      })
    },
    handleDelete(row) {
      console.log(row, '顶顶顶顶')
      var that = this
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          that.form.scenesInfos.forEach((v, index) => {
            if (v.sceneId == row.sceneId) {
              const scenesInfos = JSON.parse(JSON.stringify(that.form.scenesInfos))
              scenesInfos.splice(index, 1)
              that.form.scenesEditParams = scenesInfos
              editSys(that.form)
                .then((res) => {
                  that.$message.success('删除成功', 3)
                  that.form.scenesInfos.splice(index, 1)
                  // this.$emit('ok')
                })
                .finally(() => {
                  that.submitLoading = false
                  that.showLoading = false
                })
            }
          })
          console.log(that.form.scenesInfos, 'form.scenesInfoform.scenesInfo')
        },
        onCancel() {},
      })
    },
    onClose() {
      this.open = false
      this.form = {}
    },
  },
}
</script>

<style scoped>
.ant-image {
  display: block;
}
.button_add {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>